export default class DialogMemento {

    constructor(contentLabel, commandSequenceId, imageId) {
        this.contentLabel = contentLabel;
        this.commandSequenceId = commandSequenceId;
        this.imageId = imageId;
    }

}
